import { t } from '@/Support/lang'
import { FleetingLabelDuration } from '@/Support/Global/Interfaces/FleetingLabelDuration'
import { useNotifications } from '@/stores/notifications'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { UserData } from '@/Support/Users/Interfaces/UserData'

export const teamSwitchNotification = () => {
  const { newMiniNotification } = useNotifications()
  const user = computed(() => usePage().props.user as unknown as UserData)
  newMiniNotification({
    title: t('teams.switch.title', {
      name: user.value.currentTeam.name,
    }),
    fleeting: true,
    duration: FleetingLabelDuration.Slower,
  })
}
